/**
 * /frontend/src/features/analytics/components/shared/EmptyState.js
 */

import React from 'react';
import './EmptyState.css';

/**
 * Empty state block.
 * @param {{message:string}} props
 * @returns {JSX.Element}
 */
const EmptyState = ({ message }) => (
  <div className="analytics-empty" role="status">
    {message}
  </div>
);

export default EmptyState;

